import { render, staticRenderFns } from "./GameOverScreen.vue?vue&type=template&id=63865c16&scoped=true&"
import script from "./GameOverScreen.vue?vue&type=script&lang=ts&"
export * from "./GameOverScreen.vue?vue&type=script&lang=ts&"
import style0 from "./GameOverScreen.vue?vue&type=style&index=0&id=63865c16&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63865c16",
  null
  
)

export default component.exports